import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { Box, Heading } from '@hover/blueprint';
import { ISiteData } from '../../interfaces/ISiteData';
import { ITermsOfUseContent } from '../../interfaces/ITermsOfUseContent';

interface Props {
  termsContent: Array<ITermsOfUseContent>;
}

const Content: React.FC<Props> = ({ termsContent }) => {
  const {
    site: {
      siteMetadata: { contact },
    },
  } = useStaticQuery<ISiteData>(graphql`
    query ContactQuery {
      site {
        siteMetadata {
          contact {
            email
          }
        }
      }
    }
  `);
  return (
    <>
      {termsContent.map((content, index) => (
        <Box key={content.id} flexDir="column" position="relative">
          <Box
            w="100%"
            h="1px"
            position="absolute"
            top={{ base: '120px', tablet: '90px' }}
            left={0}
            id={content.id}
          />
          <Box mt={index === 0 ? 0 : 800}>
            <Heading as="p" size={500} fontWeight={700} mr={100}>
              {index + 1}.
            </Heading>
            <Heading as="h2" size={500} fontWeight={700}>
              {content.title}
            </Heading>
          </Box>
          {content.renderContent(contact)}
        </Box>
      ))}
    </>
  );
};

export default Content;
